/* eslint-disable react/prop-types */
import { useRef, useState } from "react";
import { useUser } from "../context/userContext";
import { doc, updateDoc } from "@firebase/firestore";
import { db } from "../firebase/firestore";
import { IoClose } from "react-icons/io5";

function Roulette({
  triggerHapticFeedback,
  imageRef,
  spinning,
  setSpinning,
  setResult,
  result,
  setIsDisabled,
  setPoints,
  handleClaim,
  setClicks,
  changeTap,
  setShowAlert,
}) {
  const { setEnergy, tapValue, multiplierSpin, setMultiplierSpin, id, energy } =
    useUser();
  const numbers = Array.from({ length: 37 }, (_, i) => i);
  const wheelRef = useRef(null);
  const modalRef = useRef(null);
  const [openModal, setOpenModal] = useState(false);
  const [rotation, setRotation] = useState(0);

  const getColor = (number) => {
    if (number === 0) return "green";
    return number % 2 === 0 ? "black" : "red";
  };

  const anglePerNumber = 360 / numbers.length;

  const handleClick = (e) => {
    // Check if changeTap is greater than both energy and multiplierSpin
    // If multiplierSpin is available but less than changeTap, prevent spin
    if (multiplierSpin > 0 && changeTap > multiplierSpin) {
      setShowAlert(true);
      setTimeout(() => setShowAlert(false), 4000);
      return;
    }

    // If no multiplierSpin and not enough energy, prevent spin
    if (multiplierSpin <= 0 && changeTap > energy) {
      setShowAlert(true);
      setTimeout(() => setShowAlert(false), 4000);
      return;
    }

    setSpinning(true);
    triggerHapticFeedback();

    const { offsetX, offsetY, target } = e.nativeEvent;
    const { clientWidth, clientHeight } = target;

    const horizontalMidpoint = clientWidth / 2;
    const verticalMidpoint = clientHeight / 2;

    const animationClass =
      offsetX < horizontalMidpoint
        ? "wobble-left"
        : offsetX > horizontalMidpoint
        ? "wobble-right"
        : offsetY < verticalMidpoint
        ? "wobble-top"
        : "wobble-bottom";

    imageRef.current.classList.remove(
      "wobble-top",
      "wobble-bottom",
      "wobble-left",
      "wobble-right"
    );
    imageRef.current.classList.add(animationClass);

    setTimeout(() => {
      imageRef.current.classList.remove(animationClass);
    }, 500);

    const rect = e.target.getBoundingClientRect();
    const newClick = {
      id: Date.now(),
      x: e.clientX - rect.left,
      y: e.clientY - rect.top,
    };
    if (multiplierSpin <= 0) {
      setEnergy((prevEnergy) => {
        const newEnergy = prevEnergy - changeTap;
        return Math.max(newEnergy, 0);
      });
    }

    const randomNumber = Math.floor(Math.random() * numbers.length);
    const targetRotation = 360 * 5 + randomNumber * anglePerNumber;
    setRotation(targetRotation);

    setTimeout(() => {
      setSpinning(false);
      setResult(randomNumber);

      // Calculate points based on multiplierSpin
      let newPoint;
      if (multiplierSpin > 0) {
        newPoint = randomNumber * tapValue.value * 3 * changeTap;
        // Decrease multiplierSpin by 1
        setMultiplierSpin((prev) => prev - changeTap);
        // Update multiplierSpin in database
        if (id) {
          const userRef = doc(db, "telegramUsers", id.toString());
          updateDoc(userRef, {
            multiplierSpin: multiplierSpin - changeTap,
          }).catch((error) => {
            console.error("Error updating multiplier spin:", error);
          });
        }
      } else {
        newPoint = randomNumber * tapValue.value * changeTap;
      }

      setPoints((prevPoints) => prevPoints + newPoint);
      handleClaim(newPoint);

      // Show multiplier feedback to user
      // if (multiplierSpin > 0) {
      //   setMsg(`3x Multiplier Applied! Won ${newPoint} points!`);
      // } else {
      //   setMsg(`Won ${newPoint} points!`);
      // }
    }, 3000);

    setTimeout(() => {
      setClicks((prevClicks) => [...prevClicks, newClick]);
    }, 6000);
  };

  return (
    <div className="w-full max-w-md mx-auto text-center">
      <div className="relative w-[18rem] h-[18rem] mx-auto mb-6">
        <div
          ref={wheelRef}
          className={`absolute inset-0 rounded-full border-8 border-red-800 ${
            spinning ? "animate-spin" : ""
          }`}
          style={{
            transform: `rotate(${-rotation}deg)`,
            transition: spinning ? "none" : "transform 0.5s ease-out",
          }}
        >
          {numbers.map((number, index) => (
            <div
              key={number}
              className="absolute w-6 h-[8.5rem] origin-bottom left-1/2 -ml-3"
              style={{ transform: `rotate(${(index * 360) / 37}deg)` }}
            >
              <div
                className={`w-full h-full ${
                  getColor(number) === "red"
                    ? "bg-red-600"
                    : number === 0
                    ? "bg-green-600"
                    : "bg-black"
                }`}
              ></div>
              <span className="absolute top-2 left-1/2 transform -translate-x-1/2 text-white text-[10px]">
                {number}
              </span>
            </div>
          ))}
        </div>
        <div className="absolute inset-0 transform translate-x-1/2 translate-y-1/2 flex items-center justify-center bg-black w-[9rem] h-[9rem] rounded-full">
          <div className="cursor-pointer">
            <img
              src="/cheesespin.png"
              alt="Cheese Logo"
              className={`wobble-image select-none ${
                spinning ? "cursor-not-allowed" : ""
              }`}
              ref={imageRef}
              onPointerDown={spinning ? undefined : handleClick}
            />
          </div>
        </div>
        <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-0 h-0 border-l-[10px] border-r-[10px] border-t-[28px] border-transparent border-t-white z-10"></div>
      </div>
      <div
        className={`${
          openModal ? "flex" : "hidden"
        } fixed bottom-0 left-0 z-40 right-0 h-[100vh] bg-[#303030c4] flex-col justify-end items-center`}
      >
        <div
          ref={modalRef}
          className={`w-full bg-divider shadowtop rounded-tl-[40px] rounded-tr-[40px] relative flex flex-col ease-in duration-300 transition-all justify-center`}
        >
          <div className="w-full flex taskbg rounded-tl-[40px] rounded-tr-[40px] mt-[2px] justify-center relative flex-col items-center space-y-3 p-4 pt-20 pb-10">
            <button
              onClick={() => setOpenModal(false)}
              className="flex items-center justify-center h-[32px] w-[32px] rounded-full bg-[#383838] absolute right-6 top-4 text-center font-medium text-[16px]"
            >
              <IoClose size={20} className="text-[#9995a4]" />
            </button>
            <span>You dont have enough spins</span>
            <div className="w-full flex justify-between items-center gap-2 px-4">
              <div className="w-[47%] h-[2px] bg-cards2"></div>
              <span className="">or</span>
              <div className="w-[47%] h-[2px] bg-cards2"></div>
            </div>
            <div className="w-full flex justify-center items-center flex-col space-y-2 pb-7">
              <button
                // onClick={() => setOpenUpgradeTwo(true)}
                className="bg-btn4 w-full py-[18px] px-6 text-nowrap flex items-center justify-center text-center rounded-[12px] font-semibold text-[17px]"
              >
                Buy more Spins
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Roulette;
